import Customer from '@/api/services/customer'

const state = {
    data: null
}

const getters ={
    fullData(state) {
        return state.data
    },

    cardData(state) {
        if (state.data === null) {
            return null
        }

        return {
            fullName: `${state.data.authPerson.firstName} ${state.data.authPerson.lastName}`,
            cardNumber: `${state.data.customerData.partCard1 || ''} ${state.data.customerData.partCard2 || ''} ${state.data.customerData.partCard3 || ''}`
        }
    },

    companyData(state) {
        if (state.data === null) {
            return null
        }

        return {
            fullName: state.data.customerName,
            info: [
                `NIP: ${state.data.customerNip}`,
                `${state.data.customerAddress.street} ${state.data.customerAddress.houseNo}${state.data.customerAddress.houseNo2 ? '/' + state.data.customerAddress.houseNo2 : ''}, ${state.data.customerAddress.town}`
            ]
        }
    }
}

const mutations = {
    setCustomerData(state, data) {
        state.data = data
    },

    clearCustomerData(state) {
        state.data = null
    }
}

const actions = {
    get() {
        return Customer().getCustomer().then(response => {
            return Promise.resolve(response)
        })
    },

    // eslint-disable-next-line
    saveMarketingConsents(store, payload) {
        return Customer().postSaveMarketingConsents(payload)
    }
}

export default {
    state,
    getters,
    mutations,
    actions,
    namespaced: true
}
